<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>3. {{ $t('cableManagement') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('cableManagementC2State') }}</div>
        <div>{{ $t(project.serviceReport.cableManagementC2State) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.serviceCableManagementAttachments"
      fieldName="cableManagementAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.serviceCableAlongFacadeAttachments"
      fieldName="cableAlongFacadeAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'CableManagementPrintPage2',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
